var map = {
	"./battle-selected.svg": 2135,
	"./battle.svg": 939,
	"./collection-selected.svg": 5929,
	"./collection.svg": 2169,
	"./hamburger-selected.svg": 6492,
	"./hamburger.svg": 2414,
	"./home-selected.svg": 50,
	"./home.svg": 5040,
	"./shop-selected.svg": 7773,
	"./shop.svg": 3821,
	"./user-selected.svg": 5778,
	"./user.svg": 9408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6223;